// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__29bxb"};